<!-- Start Footer End -->
<footer class="footer-area">
    <p>Copyright (c). COCA-COLA BOTTLERS JAPAN INC. All rights reserved.</p>
</footer>
<!-- End Footer End -->

<div class="chartjs-colors"> <!-- To use template colors with Javascript -->
    <div class="bg-primary"></div>
    <div class="bg-primary-light"></div>
    <div class="bg-secondary"></div>
    <div class="bg-info"></div>
    <div class="bg-success"></div>
    <div class="bg-success-light"></div>
    <div class="bg-danger"></div>
    <div class="bg-warning"></div>
    <div class="bg-purple"></div>
    <div class="bg-pink"></div>
</div>